import React from 'react';
import { find } from 'lodash';
import { Select, MenuItem } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../../../defaults/ColorConstants';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    "&:hover": {
      borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`,
    }
  },
});

const style = {
  select: {
    flex: '0 0 0px',
    padding: '0 5px'
  }
};

export default function OperatorChooser({selectedOperator, operators, onChange}) {
  const classes = useStyles();
  const handleOnChange = value => {
    onChange(find(operators, { alias: value.target.value }));
  };

  const getOptions = operators => {
    return operators.map(operator => {
      return (
        <MenuItem value={operator.alias} key={operator.alias} classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>
          {operator.alias}
        </MenuItem>
      );
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Select
        style={style.select}
        value={selectedOperator && selectedOperator.alias}
        disabled={!operators.length}
        onChange={handleOnChange}
        sx={{ width: 100 }}
        MenuProps={{
              sx: {
                "&& .Mui-selected": {
                  borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`
                },
              }
            }}
      >
        {getOptions(operators)}
      </Select>
    </ThemeProvider>
  );
}